import { Auth } from "aws-amplify";
import axios from "axios";
import rateLimit from "axios-rate-limit";
import history from "./history";

const authenticatedRequest = rateLimit(axios.create({
	baseURL: process.env.REACT_APP_API_URL,
}), { maxRPS: 3 });
authenticatedRequest.getMaxRPS();


authenticatedRequest.interceptors.request.use(
	async (config) => {
		const data = await Auth.currentSession();
		config.headers.Authorization = `Bearer ${data.accessToken.jwtToken}`;
		// BEZ-5699: seller-api attributes portal vs direct API via this header.
		config.headers["X-Traffic-Source"] = "seller_portal";
		return config;
	},
	(error) => {
		return Promise.reject(error);
	},
);

authenticatedRequest.interceptors.request.use(
	(request) => {
		if (!request.headers) {
			request.headers = {};
		}
    
		return request;
	},
	(error) => {
		return Promise.reject(error);
	},
);

authenticatedRequest.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		// 401 / network failures are session-level problems — send the user to the error page.
		// 403 permission denials are returned to the caller so UI can show an actionable message
		// (e.g. Add User) instead of redirecting to the generic error page.
		// 404 status is handled via MainPanel.
		if ((error.response && error.response.status === 401) ||
		error.message === "Network Error") {
			history.replace("/error");
			return Promise.reject(error);
		}
		return Promise.reject(error);
	},
);

export default authenticatedRequest;
